import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Header from './Header';
import Footer from './Footer';

import Home from './Home';
import About from './About';
import Operations from './Operations';
import Products from './Products';
import Market from './Market';
import Contact from './Contact';
import WhatsAppButton from './WhatsAppButton';
import ScrollToTop from './ScrollToTop'; // ✅ Scroll to top on route change

import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* ✅ Scrolls to top when route changes */}
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/operations" element={<Operations />} />
          <Route path="/products" element={<Products />} />
          <Route path="/market" element={<Market />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
